
export const FETCH_SPECIAL = 'FETCH_SPECIAL';

export const FETCH_FLOATINFO = 'FETCH_FLOATINFO';

export const FETCH_PDFINFO = 'FETCH_PDFINFO';

export const SEND_STATE = 'SEND_STATE';

export const PHONE_VERIFYSUCESS = 'PHONE_VERIFYSUCESS';
export const PHONE_VERIFYERROR = 'PHONE_VERIFYERROR';

export const CODE_CHECK_ACTION = 'CODE_CHECK_ACTION';
